var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "emd-panel__section" }, [
      _c("div", { staticClass: "emd-panel__block" }, [
        _c("div", { staticClass: "el-chunk" }, [
          _c("h2", { staticClass: "emd-text _color_default _type_caption" }, [
            _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "emd-panel__block" }, [
        _c("div", { staticClass: "emd-form-group" }, [
          _c("label", { staticClass: "emd-label" }, [
            _vm._v(" " + _vm._s(_vm.$t("status")) + " "),
          ]),
          _c(
            "label",
            { staticClass: "emd-label" },
            [
              _c(
                "jade-tag",
                {
                  staticClass: "eu-mt_2",
                  attrs: { variant: _vm.kycStatus.color, size: "medium" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t(`status-reason.${_vm.kycStatus.status}`)) +
                      " "
                  ),
                ]
              ),
              _c(
                "emd-tippy",
                {
                  staticClass: "eu-ml_2",
                  attrs: {
                    type: "simple",
                    position: "right",
                    content: _vm.$t(`status-reason-description.${_vm.status}`),
                  },
                },
                [_c("i", { staticClass: "uil uil-info-circle" })]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }